export default "__VITE_ASSET__CTXmk3aI__"